"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  id: 727,
  opportunityId: 270,
  resumeUrl: 'https://api-dev-employer.hellohive.com/v1/employer/applicants/727/student/resume',
  applyDate: '2021-08-02T03:48:13.000000Z',
  coverLetter: null,
  transcript: null,
  portfolioUrl: null,
  transcriptShort: null,
  portfolioUrlShort: null,
  tag: null,
  status: null,
  externalLinkSended: false,
  whyOurCompanyReason: 'asdf',
  contactTag: null,
  isAgree: true,
  opportunityLocation: null,
  opportunityLocationId: null
};
exports.default = _default;